<template>
  <div class="page-is-locked flex-mid">
    <div class="center">
      <img src="../../assets/images/components/page-locked/lock_black_52dp.png" alt="icons_arrow_down_red_24dp@2x" />
      <div class="mt-8">
        This view is restricted to
      </div>
      <div>Super Leaders, Super Admins, and HR roles only.</div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
  },
  watch: {},
  data() {
    return {
      path: "",
    };
  },
  mounted() {
    this.path = this.$router.currentRoute.path.split("-").join("_");
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-is-locked {
  height: 398px;
  width: 100%;
  border-radius: 4px;
  margin-top: 32px;
  background-color: #0000000a;
  border: 1px solid #0000001a;
  color: rgba(#000, 0.4);
  font-size: 14px;
  font-weight: 700;
}
</style>
